<template>
  <app-modal v-model="isDialogOpened"
             hide-header
             hide-footer
             size="xl"
  >
    <template #body>
      <template v-if="imanageFolderPickerPending">
        <div class="text-center">
          <AppLoader/>
        </div>
      </template>
      <iframe v-if="iframeSrc"
              class="IManageFolderPickerDialog-iframe"
              :src="iframeSrc.dialogUrl"
              title="IManage Folder Picker"
      ></iframe>
    </template>
  </app-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import AppLoader from '@/common/AppLoader.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { GET_IMANAGE_FOLDER_PICKER } from '@/store/modules/imanage/action_types'

export default {
  name: 'IManageFolderPickerDialog',
  components: { AppLoader },
  mixins: [dialogMixin],
  emits: ['folders', 'update:isOpen'],
  data () {
    return {
      iframeSrc: null,
      iManageEventHandlerIsActive: false,
    }
  },
  computed: {
    ...mapState('imanage', ['authCode', 'imanageFolderPickerPending']),
  },
  mounted () {
    this.prepareGetIManageFolderPicker()
    this.iManageEventHandlerIsActive = true
    window.addEventListener('message', e => { this.handleIManageReturns(e) }, false)
  },
  beforeUnmount() {
    this.iManageEventHandlerIsActive = false
    window.removeEventListener('message', e => { this.handleIManageReturns(e) }, false)
  },
  methods: {
    ...mapActions('imanage', [GET_IMANAGE_FOLDER_PICKER]),
    async prepareGetIManageFolderPicker () {
      try {
        this.iframeSrc = await this.GET_IMANAGE_FOLDER_PICKER()
      } catch (error) {
        if (error.response?.data?.errorCode === 'ERR_REQUIRE_IMANAGE_AUTH' && this.authCode) {
          toast.error(this.$t('common.imanage.IManageFolderPickerDialog.notAuth'))
        } else {
          toast.error(this.$t('common.iManage.unavailable'))
        }
        this.destroyIManageIframe()
      }
    },
    handleIManageReturns (e) {
      if (e.data) {
        if (this.iManageEventHandlerIsActive) {
          const event = e.data
          switch (event.type) {
            case 'cancel':
              this.destroyIManageIframe()
              break
            case 'select':
              this.getFolderFromImanage(event.data)
              break
          }
        }
      }
    },
    destroyIManageIframe () {
      this.iframeSrc = null
      this.$emit('update:isOpen', false)
    },
    getFolderFromImanage (folders) {
      this.$emit('folders', folders)
      this.destroyIManageIframe()
    },
  },
}
</script>

<style scoped lang="scss">
.IManageFolderPickerDialog-iframe {
  width: 100%;
  height: 75vh;
  overflow-y: auto;
}
</style>
